import type { ComponentProps } from "react";
import Ionicons from "@expo/vector-icons/Ionicons";
import { useRouter } from "expo-router";
import { useTranslation } from "react-i18next";

import { HelpIntro, HelpScreen, MenuRow } from "@/components/help/help-ui";
import i18n from "@/i18n";

type IoniconName = ComponentProps<typeof Ionicons>["name"];

type MenuItem = {
  icon: IoniconName;
  title: string;
  subtitle: string;
  href: string;
};

const MENU: MenuItem[] = [
  {
    icon: "shield-checkmark-outline",
    get title() {
      return i18n.t("help.home.safeTitle");
    },
    get subtitle() {
      return i18n.t("help.home.safeBody");
    },
    href: "/help/staying-safe",
  },
  {
    icon: "flag-outline",
    get title() {
      return i18n.t("help.home.reportTitle");
    },
    get subtitle() {
      return i18n.t("help.home.reportBody");
    },
    href: "/help/report-problem",
  },
  {
    icon: "bulb-outline",
    get title() {
      return i18n.t("help.home.feedbackTitle");
    },
    get subtitle() {
      return i18n.t("help.home.feedbackBody");
    },
    href: "/help/feedback",
  },
  {
    icon: "chatbubbles-outline",
    get title() {
      return i18n.t("help.home.contactTitle");
    },
    get subtitle() {
      return i18n.t("help.home.contactBody");
    },
    href: "/help/contact?source=contact",
  },
  {
    icon: "people-outline",
    get title() {
      return i18n.t("help.home.guidelinesTitle");
    },
    get subtitle() {
      return i18n.t("help.home.guidelinesBody");
    },
    href: "/help/community-guidelines",
  },
  {
    icon: "lock-closed-outline",
    get title() {
      return i18n.t("help.home.privacyTitle");
    },
    get subtitle() {
      return i18n.t("help.home.privacyBody");
    },
    href: "/help/privacy-account",
  },
  {
    icon: "card-outline",
    get title() {
      return i18n.t("help.home.billingTitle");
    },
    get subtitle() {
      return i18n.t("help.home.billingBody");
    },
    href: "/help/billing-plus",
  },
];

export default function HelpCenter() {
  useTranslation();
  const router = useRouter();

  return (
    <HelpScreen title={i18n.t("help.home.title")}>
      <HelpIntro>{i18n.t("help.home.intro")}</HelpIntro>
      {MENU.map((item) => (
        <MenuRow
          key={item.href}
          icon={item.icon}
          title={item.title}
          subtitle={item.subtitle}
          onPress={() => router.push(item.href as never)}
        />
      ))}
    </HelpScreen>
  );
}
